import moment from 'moment';
import { useJobsSummary } from 'src/hooks/dashboard';
import { useCountries } from 'src/hooks/country';
import { tryCall } from 'src/utils/core/functions';

export default () => {
  const { data: countriesData, loading: countriesLoading } = tryCall(() => useCountries({
    offset: 0,
    limit: 1000,
    withDeleted: true,
  }), { data: [], loading: false });
  const countries = (countriesData && countriesData.countries) || [];

  const [getJobsSummary, { data: jobsSummaryData, loading: jobsSummaryLoading }] = tryCall(() => useJobsSummary({
    startDate: moment().startOf('isoWeek'),
    endDate: moment().endOf('isoWeek')
  }), [() => {}, { data: null, loading: false }]);

  return {
    jobsSummary: (jobsSummaryData && jobsSummaryData.jobsSummaryDashboard) || {},
    jobsSummaryLoading,
    getJobsSummary,
    countries,
    countriesLoading,
  };
};
